import React from "react";
import "../fonts.css";
import BackgroundCellAnimation from "../components/contactuspage/BackgroundRippleEffect";
import Form from "../components/contactuspage/form";
function Contactus(){
    document.body.style = 'background: black;';
    return(
        <div>
            <BackgroundCellAnimation/>
        </div>
    );
}

export default Contactus;